/* eslint-disable no-unused-vars */
import { ImportExport } from '@mui/icons-material';
import { Card, Grid, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import Down from 'assets/icons/down.svg';
import VectorUp from 'assets/images/vector_up.png';
import PropTypes from 'prop-types';
import {
  bgGreen,
  displayFlex,
  fontsize16,
  fontsize32,
  poppins500,
  poppins600,
} from 'theme/common.style';
import {
  centerContent,
  forCastCard,
  postCntl,
} from './VariationValueDetails.style';

function VariationValueDetails(props) {
  const { title, showProgressBar, avg, sector1, expanded } = props;

  const theme = useTheme();
  const matches500 = useMediaQuery(theme.breakpoints.down(500));

  return (
    <Card sx={[{ backgroundColor: '#FAFAFA', minWidth: '100%' }, forCastCard]}>
      <Grid
        container
        gap={matches500 ? 4 : 7}
        item
        sx={displayFlex}
        style={{
          justifyContent: 'center',
        }}
      >
        <Grid item xs={2} sx={centerContent}>
          <Typography
            sx={{ ...poppins600, fontSize: matches500 ? '20px' : '32px' }}
          >
            {avg
              ? sector1?.leftColumn?.campaignInspectedCount
              : sector1?.leftColumn?.inspectedCountForWeek}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: matches500 ? '10px' : '14px',
              fontWeight: '400px',
              whiteSpace: 'nowrap',
            }}
          >
            {avg
              ? 'Campaign'
              : 'Week' + `${' '}` + `${sector1?.leftColumn?.week}`}
          </Typography>
        </Grid>
        <Grid item xs={2} sx={centerContent}>
          <Typography
            sx={{ ...poppins500, ...fontsize16, ...bgGreen, ...postCntl }}
          >
            <Typography sx={{ ...poppins500, ...fontsize16, ...bgGreen }}>
              {avg
                ? sector1?.leftColumn?.campaignVariation
                : sector1?.leftColumn?.variation}
              %&nbsp;
            </Typography>
            {avg ? (
              sector1?.leftColumn?.campaignVariation > 0 ? (
                <img src={VectorUp} width={10} height={15} alt="Live" />
              ) : sector1?.leftColumn?.campaignVariation < 0 ? (
                <img src={Down} width={10} height={15} alt="Live" />
              ) : (
                <ImportExport />
              )
            ) : sector1?.leftColumn?.variation > 0 ? (
              <img src={VectorUp} width={10} height={15} alt="Live" />
            ) : sector1?.leftColumn?.variation < 0 ? (
              <img src={Down} width={10} height={15} alt="Live" />
            ) : (
              <ImportExport />
            )}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: matches500 ? '10px' : '14px',
              fontWeight: '400px',
            }}
          >
            Variation
          </Typography>
        </Grid>
        <Grid item sx={centerContent} xs={2}>
          <Typography
            sx={{ ...poppins600, fontSize: matches500 ? '20px' : '32px' }}
          >
            {avg
              ? sector1?.leftColumn?.campaignMarketAvg
              : sector1?.leftColumn?.marketAvg}
          </Typography>
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: matches500 ? '10px' : '14px',
              fontWeight: '400px',
              whiteSpace: 'nowrap',
            }}
          >
            Market Avg
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
}

VariationValueDetails.defaultProps = {
  showProgressBar: true,
};

VariationValueDetails.propTypes = {
  title: PropTypes.string.isRequired,
  showProgressBar: PropTypes.bool,
};

export default VariationValueDetails;
